import "./OralAppliances.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import OurClinicalVision from "./sections/OurClinicalVision";
import EvaluationProcess from "./sections/EvaluationProcess";
import InquireAboutSurgery from "./sections/InquireAboutSurgery";
import PatientResources from "@/reusable_sections/Footer";
export default function OralAppliancesPage() {
  return <div>
      <ClinicHeader />
      <OurClinicalVision />
      <EvaluationProcess />
      <InquireAboutSurgery />
      <PatientResources />
    </div>;
}